import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpResponse, HttpParams } from '@angular/common/http';

import { HomeData } from '../models/homeData.model';
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private Url: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
  }

  getAssistantStats() {
    return this.http.get<HomeData>(this.Url + 'api/home/getAssistantStats');
  }
}
